import client from './client';

// type: 'passport' | 'accommodation' — each has its own /{type}-requests endpoints and permissions.
export async function listRequestCandidates(type, params) {
  const { data } = await client.get(`/${type}-requests/candidates`, { params });
  return data.data;
}

export async function createCandidateRequest(type, payload) {
  const { data } = await client.post(`/${type}-requests`, payload);
  return data.data;
}

export async function listCandidateRequests(type, params) {
  const { data } = await client.get(`/${type}-requests`, { params });
  return data.data;
}

export async function candidateRequestCount(type) {
  const { data } = await client.get(`/${type}-requests/count`);
  return data.data.count;
}

export async function approveCandidateRequest(type, id) {
  const { data } = await client.post(`/${type}-requests/${id}/approve`);
  return data.data;
}

export async function rejectCandidateRequest(type, id, review_remarks) {
  const { data } = await client.post(`/${type}-requests/${id}/reject`, { review_remarks });
  return data.data;
}

export async function updateCandidateRequestDate(type, id, scheduled_date) {
  const { data } = await client.patch(`/${type}-requests/${id}/date`, { scheduled_date });
  return data.data;
}

export async function updateCandidateRequestLocation(type, id, request_location_id) {
  const { data } = await client.patch(`/${type}-requests/${id}/location`, { request_location_id });
  return data.data;
}

export async function listRequestLocations(params) {
  const { data } = await client.get('/request-locations', { params });
  return data.data;
}

export async function createRequestLocation(payload) {
  const { data } = await client.post('/request-locations', payload);
  return data.data;
}

export async function updateRequestLocation(id, payload) {
  const { data } = await client.put(`/request-locations/${id}`, payload);
  return data.data;
}

export async function deleteRequestLocation(id) {
  await client.delete(`/request-locations/${id}`);
}
